"use client";

import { Input } from "@watt/ui/components/ui/input";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type React from "react";
import { useVerification } from "./verification-context";

export interface VerificationValueProps
  extends Omit<
    React.ComponentPropsWithoutRef<typeof Input>,
    "value" | "onChange"
  > {
  ref?: React.Ref<HTMLInputElement>;
}

export function VerificationValue({
  className,
  disabled = true,
  ref,
  ...props
}: VerificationValueProps) {
  const { state } = useVerification();

  return (
    <Input
      className={cn("text-muted-foreground", className)}
      disabled={disabled}
      readOnly
      ref={ref}
      value={state.value}
      {...props}
    />
  );
}
